import React from "react";
import "./style.css";

import PropTypes from "prop-types";
import { FormControl, FormErrorMessage, FormLabel, Input, InputGroup, InputRightElement } from "@chakra-ui/react";

const TextInput = ({ group, placeholder, className, onChange, label, labelClassName, inputName, errMessage, rightElement, leftElement, inputCover, defaultValue, value, readonly, isRequired, disabled, onKeyDown }) => {
  const updateString = (str) => {
    if (onChange) onChange(str);
  };

  return (
    <FormControl className="text-field-form-control" isInvalid={errMessage} isRequired={isRequired}>
      <label className={labelClassName}>
        <FormLabel className='text-field-label'>{label || ""}</FormLabel>
        <div className={`custom-cover ${inputCover}`}>
          <InputGroup className="text-input-group">
            {leftElement ? (
              <InputRightElement pointerEvents="none" children={`${leftElement || ""}`} className="input-left-elem" />
            ) : ""}

            <Input
              type="text"
              name={inputName}
              placeholder={placeholder || ""}
              className={className}
              defaultValue={defaultValue}
              onChange={(e) => updateString(e.target.value)}
              errorBorderColor="#FF4242"
              datalabel={label}
              datagroup={group}
              value={value}
              readOnly={readonly}
              disabled={disabled}
              onKeyDown={onKeyDown}
            />

            {rightElement ? (
              <InputRightElement pointerEvents="none" children={`${rightElement || ""}`} className="input-right-elem" />
            ) : ""}
          </InputGroup>
          <FormErrorMessage className="form-error-message">{errMessage}</FormErrorMessage>
        </div>
      </label>
    </FormControl>
  );
};

TextInput.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  inputName: PropTypes.string,
  label: PropTypes.string,
  labelClassName: PropTypes.string,

  data: PropTypes.any,
  rightElement: PropTypes.any,
  leftElement: PropTypes.any,

  onChange: PropTypes.func,

  errMessage: PropTypes.string,
  inputCover: PropTypes.string,
};


export default TextInput;
